import { useEffect } from 'react';
import './style.scss';

const PRainbowToast = ({ message, setShow, show, customStyle={} }) => {
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShow(false);
      }, 3000);
    }
  }, [show]);

  return (
    show && (
    <div className="rainbow-toast" style={customStyle}>
      {message}
    </div>
    )
  );
};

export default PRainbowToast;
